export default "/images/vendor/flag-icons/flags/4x3/tf.svg?7e39f4397e0d054456feeaf84a8af712";